import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  mission: Yup.string()
    .required("Mission is required")
    .max(500, "Mission must be at most 500 characters long"),
  vision: Yup.string()
    .required("Vision is required")
    .max(500, "Vision must be at most 500 characters long"),
  companyOverview: Yup.string()
    .required("Company Overview is required")
    .max(1000, "Company Overview must be at most 1000 characters long"),
  companyEstablishmentDate: Yup.date().required("Company Establishment Date is required"),
  goals: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string(),
        description: Yup.string().required("Goal description is required"),
        priority: Yup.string()
          .required("Priority is required")
          .oneOf(["High", "Mid", "Low"], "Priority must be High, Medium, or Low"),
        outComes: Yup.array()
          .of(
            Yup.object().shape({
              currentStatus: Yup.string().required("Current Status is required"),
              desiredStatus: Yup.string().required("Desired Status is required")
            })
          )
          .min(1, "At least one outcome is required")
          .required("Outcomes are required"),
        duration: Yup.string().required("Duration is required"),
        personName: Yup.string().required("Person Name is required"),
        actions: Yup.array().of(Yup.string())
      })
    )
    .min(1, "At least one goal is required")
    .required("Goals are required")
});

export default validationSchema;
